import { render, staticRenderFns } from "./ContactTypeSelect.vue?vue&type=template&id=fea43250&scoped=true&lang=pug"
import script from "./ContactTypeSelect.vue?vue&type=script&lang=js"
export * from "./ContactTypeSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea43250",
  null
  
)

export default component.exports